import { TLO_STORAGE_KEY } from '~/Configurations/constants';

/**
 * Check if the current NFT platform is for The Lorry's transporter or not
 * TODO:  implement logic after the Lorry infra separation is finalized
 *        currently differentiate using query string <NFT url>?lorry=true
 * @returns {Boolean}
 */
export default function checkTheLorryTransporter() {
  // Use local storage to test in local environment
  if (process.env.NODE_ENV === 'development') {
    // need to update the logic, because on PWA we cannot set the local storage manually
    return window.localStorage.getItem('lorry') === 'true' || window.localStorage.getItem(TLO_STORAGE_KEY) === 'true';
  }

  return window.location.origin.includes('thelorry.com');
}
